import { useEffect, useState } from "react";
import SEO from "@/components/SEO";
import { api } from "@/lib/api";

export default function AdminAudit() {
  const [logs, setLogs] = useState([]);
  useEffect(() => { api.get("/admin/audit-logs").then((r) => setLogs(r.data)).catch(() => {}); }, []);
  return (
    <div>
      <SEO title="Audit Logs | Admin" />
      <h1 className="font-display text-2xl font-bold tracking-tight">Audit Logs</h1>
      <p className="text-slate-400 text-sm">Recent admin actions.</p>
      <div className="mt-5 rounded-xl border border-white/10 overflow-x-auto">
        <table className="w-full text-sm min-w-[600px]">
          <thead className="bg-white/5 text-slate-400"><tr><th className="text-left p-3">Time</th><th className="text-left p-3">Actor</th><th className="text-left p-3">Action</th><th className="text-left p-3">Entity</th></tr></thead>
          <tbody>
            {logs.map((l) => (
              <tr key={l.id} className="border-t border-white/5"><td className="p-3 text-slate-500 text-xs">{new Date(l.created_at).toLocaleString()}</td><td className="p-3 text-slate-300">{l.actor}</td><td className="p-3"><span className="px-2 py-0.5 rounded bg-white/10 text-xs">{l.action}</span></td><td className="p-3 text-slate-400">{l.entity} {l.entity_id ? `· ${l.entity_id.slice(0,8)}` : ""}</td></tr>
            ))}
            {logs.length === 0 && <tr><td colSpan={4} className="p-10 text-center text-slate-500">No activity yet.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
